export const payway = {
  2: 'aliPay', //支付宝SDK
  3: 'yinLianPay', //银联
  4: 'wxpay', //微信
  6: 'alipay_wap', //支付宝网页支付
  7: 'upacp_wap', //银联网页支付
  8: 'wx_pub', //微信公众号支付
  9: 'zhaoShangPay', //招商银行支付
  10: 'alipayPingpp', //支付宝App Ping++支付
  11: 'wx_wap' //微信H5支付
};

export const providerList = {
  1: {
    text: '糖医专供'
  },
  2: {
    text: '好药师',
    isCODOnly: true //true货到付款
  },
  3: {
    text: '国药'
  },
  4: {
    text: '健客网',
    isCODOnly: true
  },
  5: {
    text: '国一堂',
    isCODOnly: true
  },
  6: {
    text: '国一堂',
    isCODOnly: true
  },
  7: {
    text: '康爱多',
    isCODOnly: true
  },

  8: {
    text: '智云自营'
  },
  9: {
    text: '国一堂',
    isCODOnly: true
  },
  '-1': {
    text: '以下药品无法下单'
  }
};

export const cargoStatus = {
  0: '待付款', // 可支付，可取消
  1: '已取消',
  2: '已过期',
  12: '待发货', // 可退款
  21: '待收货', // 确认收货
  22: '交易完成', // 可退款
  23: '待退货',
  30: '待退款',
  31: '退款中',
  32: '已退款',
  41: '审核中',
  42: '审核中', // (用户自己上传处方下单的状态)
  43: '审方失败',
  44: '审核失败', // (用户自己上传处方下单的状态)
  45: '待开方',
  46: '已开方',
  47: '退款审核',
  51: '待取货',
  52: '交易关闭',
  81: '审核中',
  83: '待退货',
  84: '退货中',
  85: '待退款',
  86: '退款中',
  87: '已退款',
  88: '退款已关闭'
};
export const cargoStyle = {
  0: 'order-to-pay',
  1: 'order-canceled',
  2: 'order-expired',
  12: 'order-to-ship',
  21: 'order-shipping',
  22: 'order-trade-success',
  30: 'order-wait-refound',
  31: 'order-refounding',
  32: 'order-refound-success'
};
